<template>
  <el-dialog :visible.sync="visible" width="min(520px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.downtimeId" class="title-actions">
        <el-button v-if="isAuth('base:workCenterDowntime:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:workCenterDowntime:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :validate-on-rule-change="false" label-width="100px">
      <el-form-item label="机台" prop="workCenterId">
        <el-select v-model="form.workCenterId" filterable style="width:100%" :disabled="readonly">
          <el-option v-for="item in centers" :key="item.workCenterId" :label="item.workCenterCode + ' ' + item.workCenterName" :value="item.workCenterId" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="downtimeStart">
        <el-date-picker v-model="form.downtimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" :disabled="readonly" />
      </el-form-item>
      <el-form-item label="结束时间" prop="downtimeEnd">
        <el-date-picker v-model="form.downtimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" :disabled="readonly" />
      </el-form-item>
      <el-form-item label="原因"><el-input v-model="form.reason" type="textarea" :disabled="readonly" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'WorkCenterDowntimeAddOrUpdate',
  data() {
    return {
      visible: false, readonly: false, centers: [], form: this.blank(), permCodes: [],
      rules: {
        workCenterId: [{ required: true, message: '请选择机台', trigger: 'change' }],
        downtimeStart: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        downtimeEnd: [{ required: true, message: '请选择结束时间', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看停机'
      return this.form.downtimeId ? '修改停机' : '新增停机'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    blank() { return { downtimeId: '', workCenterId: '', downtimeStart: '', downtimeEnd: '', reason: '' } },
    loadCenters() { request.get('/production/workCenter/list').then(res => { this.centers = res.data || [] }).catch(() => {}) },
    init(id, readonly, defaults) {
      this.visible = true
      this.readonly = !!readonly
      this.loadCenters()
      if (!id) {
        this.form = Object.assign(this.blank(), defaults || {})
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/production/downtime/info', { params: { id } }).then(res => {
        this.form = Object.assign(this.blank(), res.data || {})
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() { this.form = this.blank(); this.readonly = false },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (this.form.downtimeEnd <= this.form.downtimeStart) {
          this.$message.warning('结束时间必须晚于开始时间')
          return
        }
        request.post('/production/downtime/save', this.form).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        request.post('/production/downtime/delete', { downtimeId: this.form.downtimeId }).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>
